"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UISearchInput = _interopRequireDefault(require("UIComponents/input/UISearchInput"));

var _UIHeader = _interopRequireDefault(require("UIComponents/layout/UIHeader"));

var _reactRedux = require("react-redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _actions = require("../actions");

var Header = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(Header, _React$PureComponent);

  function Header(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Header);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Header).call(this, props));
    _this.onFilterAccounts = _this.onFilterAccounts.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Header, [{
    key: "onFilterAccounts",
    value: function onFilterAccounts(e) {
      this.props.filterAccounts(e.target.value);
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_UIHeader.default, {
        use: "condensed",
        title: _I18n.default.text('main.header')
      }, _react.default.createElement(_UISearchInput.default, {
        onChange: this.onFilterAccounts,
        placeholder: _I18n.default.text('main.searchText')
      }));
    }
  }]);
  return Header;
}(_react.default.PureComponent);

Header.propTypes = {
  filterAccounts: _propTypes.default.func
};

var _default = (0, _reactRedux.connect)(function () {
  return {};
}, {
  filterAccounts: _actions.filterAccounts
})(Header);

exports.default = _default;
module.exports = exports.default;